// Envío de los formularios a la bandeja de contactos (Sanity) a través de la Lambda,
// que es la que tiene el token de escritura y la key de correo.
const URL_CONTACTOS = process.env.REACT_APP_CONTACTOS_URL;
const CLAVE = 'awna-origen';

const PARAMS = {
    utm_source: 'utmSource',
    utm_medium: 'utmMedium',
    utm_campaign: 'utmCampaign',
    utm_content: 'utmContent',
    utm_term: 'utmTerm',
    gclid: 'gclid',
    fbclid: 'fbclid',
};

/**
 * Guarda por dónde entró la visita. Corre una vez al cargar el sitio: los formularios
 * están en otras páginas y para entonces las UTM ya no están en la URL. Un link nuevo
 * con UTM en la misma pestaña reemplaza al anterior.
 */
export function registrarOrigen() {
    try {
        const params = new URLSearchParams(window.location.search);
        const conCampaña = Object.keys(PARAMS).some((p) => params.get(p));
        if (sessionStorage.getItem(CLAVE) && !conCampaña) return;

        const origen = {
            entrada: window.location.pathname + window.location.search,
            referente: document.referrer && !document.referrer.startsWith(window.location.origin) ? document.referrer : '',
        };
        Object.entries(PARAMS).forEach(([param, campo]) => {
            if (params.get(param)) origen[campo] = params.get(param);
        });
        sessionStorage.setItem(CLAVE, JSON.stringify(origen));
    } catch {
        // Sin sessionStorage (modo privado estricto) el contacto llega igual, sin origen
    }
}

function leerOrigen() {
    let origen = {};
    try {
        origen = JSON.parse(sessionStorage.getItem(CLAVE)) || {};
    } catch {
        // idem
    }
    return { ...origen, pagina: window.location.pathname };
}

/**
 * @param {'contacto'|'analisis360'} formulario
 * @param {{nombre, email, telefono?, empresa?, interes?, mensaje?, respuestas?: {pregunta, respuesta}[]}} datos
 * @param {string} [trampa] valor del campo oculto anti-bots
 */
export async function enviarContacto(formulario, datos, trampa = '') {
    let respuesta;
    try {
        respuesta = await fetch(URL_CONTACTOS, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ formulario, datos, origen: leerOrigen(), trampa }),
        });
    } catch {
        // Sin conexión, fetch falla con un mensaje en inglés del navegador
        throw new Error('No pudimos conectarnos. Revisa tu conexión e inténtalo de nuevo.');
    }
    if (!respuesta.ok) {
        const { error } = await respuesta.json().catch(() => ({}));
        throw new Error(error || 'No pudimos enviar el formulario');
    }
}

/**
 * Campo trampa: invisible y fuera del orden del teclado, así que solo lo llena un bot.
 * Va como hermano de los demás campos del formulario.
 */
export const PROPS_TRAMPA = {
    type: 'text',
    // Un nombre que el autocompletado del navegador no reconoce: si lo llenara, el
    // contacto real se descartaría como bot
    name: 'observaciones',
    tabIndex: -1,
    autoComplete: 'off',
    'aria-hidden': true,
    className: 'absolute -left-[9999px] h-px w-px opacity-0',
};
